import script from "./LoadingOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingOverlay.vue?vue&type=style&index=0&id=d6506346&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6506346"]])

export default __exports__